import responsiveFontSize from '../../lib/responsiveFontSize';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ImageBW from '../ImageBoundsWrapper';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import TermsModalWrapper from '../TermsModal/TermsModalComponents/TermsModalWrapper';
import ActivityIndicator from '../ActivityIndicator/ActivityIndicator';

const Star = props => {
  const {
    isVisible,
    closeModal,
    terms,
    setTerms,
    onSubmit,
    termsAndConditionsUrl,
    privacyPolicyUrl,
    isGoogleSignIn,
    googleAuth,
  } = props;
  const nonActiveBG = require(asset`RoundedRect_Grey@3x.png`);
  const activeCheckbox = require(asset`Checkbox@3x.png`);
  const nonActiveCheckbox = require(asset`Checkbox_Deselected@3x.png`);
  const activeBG = require(asset`RoundedRect_Pink@3x.png`);

  const [isGoogleButtonVisible, setIsGoogleButtonVisible] = useState(false);
  const [isActivityIndicatorVisible, setIsActivityIndicatorVisible] = useState(false);
  const timer = useRef(null);

  const renderGoogleButton = useCallback(() => {
    setIsGoogleButtonVisible(false);
    terms && setIsActivityIndicatorVisible(true);
    isGoogleSignIn &&
      window.isGsiLoaded &&
      googleAuth &&
      window.google.accounts.id.renderButton(document.getElementById('googleSignInBtn'), {
        theme: 'outline',
        width: '190',
        text: 'signin_with',
        hl: 'en',
        click_listener: () => closeModal(),
      });

      /**
       * delaying button's presentation in order
       * to prevent the user from seeing the
       * google's iframe weird glitches
       */
      timer.current = setTimeout(() => {
        setIsGoogleButtonVisible(true);
        setIsActivityIndicatorVisible(false);
      }, 900);
  }, [terms]);

  useEffect(() => {
    renderGoogleButton();
    return () => {
      clearTimeout(timer.current);
    }
  }, [renderGoogleButton]);

  return (
    <TermsModalWrapper
      isVisible={isVisible}
      closeModal={closeModal}
      title={getText(TEXT_KEY.TERMS_AND_CONDITIONS_TITLE)}
      zIndex={101}
    >
      <div className="terms-container">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '90%',
            margin: '1em auto',
          }}
        >
          <div className="accept-terms-container">
            <ImageBW
              source={terms ? activeCheckbox : nonActiveCheckbox}
              ibw={require(asset`Checkbox.ibw`)}
              style={{
                width: 50,
                height: 50,
              }}
              className="checkbox-image"
              onClick={setTerms}
            />
            <p style={{ fontSize: responsiveFontSize(12, 18) }} className="accept-terms-text" onClick={setTerms}>
              {getText(TEXT_KEY.STAR_AGE_AGREEMENT)}{' '}
              <a style={{ textDecoration: 'underline' }} onClick={() => window.open(termsAndConditionsUrl, '_blank')}>
                {getText(TEXT_KEY.TERMS_AND_CONDITIONS)}
              </a>
              {getText(TEXT_KEY.STAR_CONSENT_TO_MARKETING)}
            </p>
          </div>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <h5>{getText(TEXT_KEY.STAR_PRIVACY_COLLECTION_TITLE)}</h5>
            <p
              style={{
                fontWeight: 300,
                fontSize: responsiveFontSize(10, 15),
              }}
            >
              {getText(TEXT_KEY.STAR_PRIVACY_COLLECTION_BODY)}{' '}
              <a
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => window.open(privacyPolicyUrl, '_blank')}
              >
                {getText(TEXT_KEY.PRIVACY_POLICY)}
              </a>
              {getText(TEXT_KEY.STAR_PRIVACY_POLICY_PART_ONE)}{' '}
              <a
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => window.open(privacyPolicyUrl, '_blank')}
              >
                {getText(TEXT_KEY.PRIVACY_POLICY)}
              </a>{' '}
              {getText(TEXT_KEY.STAR_PRIVACY_POLICY_PART_TWO)}
            </p>
          </div>
        </div>
      </div>
      <div className="terms-footer">
      {isActivityIndicatorVisible && <ActivityIndicator customStyle={{ top: 'unset', bottom: '20px'}}/>} 
        {isGoogleSignIn && terms && (
          <div style={{ height: '44px', width: 'auto', opacity: isGoogleButtonVisible ? 1 : 0 }}>
            <div style={{ display: 'flex', justifyContent: 'center' }} id="googleSignInBtn" />
          </div>
        )}
        {!isGoogleSignIn && (
          <div className="continue-button-container" onClick={terms ? onSubmit : null}>
            <ImageBW
              source={terms ? activeBG : nonActiveBG}
              ibw={require(asset`Continue_Button.ibw`)}
              style={{ objectFit: 'contain' }}
              className="continue-button"
              innerStyle={{
                cursor: 'pointer',
              }}
            >
              <div className="continue-button-content">
                <p className="continue-button-text">{getText(TEXT_KEY.CONTINUE_BUTTON)}</p>
              </div>
            </ImageBW>
          </div>
        )}
      </div>
    </TermsModalWrapper>
  );
};

export default Star;

